import { useIntl } from "@components/Intl"
import { ChoicesProductGroupFilter, ChoicesStyleFilter } from "@generated"
import { ProductGroupFilter, StyleFilter } from "@globalTypes"
import { useRelatedCombinations } from "@lib/hooks/use-related-combinations"
import { CalloutCardCollectionDetailPage } from "@lib/kontent/models/CalloutCardCollectionDetailPage"
import { useRouter } from "next/router"
import * as qs from "query-string"
import React, { useEffect, useState } from "react"
import Filters from "./Filters"
import Grid from "./Grid"
import { uidToProductgroups } from "./filterOptions"

export interface FilterState {
  style: string
}

interface Props {
  uid: string
  prefix: string
  href: string
  callOutCards: CalloutCardCollectionDetailPage[]
}

const ArticleCombinationGrid: React.FC<Props> = ({
  uid,
  prefix,
  callOutCards,
}) => {
  const router = useRouter()
  const { messages } = useIntl()

  let style = (router && (router.query["style"] as string)) || "classic"
  if (uid === "earrings") {
    style = (router && (router.query["style"] as string)) || "hippiechic"
  }
  const [state, setState] = useState<FilterState>({
    style,
  })

  const filters = {
    productGroup: ProductGroupFilter[
      uidToProductgroups[uid]
    ] as ChoicesProductGroupFilter,
    style: StyleFilter[state.style] as ChoicesStyleFilter,
  }
  const { status, isFetchingNextPage, items } = useRelatedCombinations(filters)

  useEffect(() => {
    if (router && router.asPath) {
      const split = router.asPath.split("?")
      if (split[1]) {
        const parsed = qs.parse(split[1])
        let style = (parsed && (parsed["style"] as string)) || "classic"
        if (uid === "earrings") {
          style = (parsed && (parsed["style"] as string)) || "hippiechic"
        }
        setState({
          style,
        })
      }
    }
  }, []) // eslint-disable-line

  const handleStyle = (style) => {
    const newState = {
      style,
    }
    setState(newState)
    urlSync(newState)
  }

  function urlSync(state: FilterState) {
    let args = {
      style: state.style,
    }

    const url = `${window.location.pathname}${qs.stringify(args)}`
    if (url !== `${window.location.pathname}${window.location.search}`) {
      router.replace(
        `/[lang]${messages.navigation.collectionDetail.url}`,
        {
          pathname: window.location.pathname,
          query: args,
        },
        {
          shallow: true,
        }
      )
    }
  }

  return (
    <>
      <Filters style={state.style} uid={uid} onSelectStyle={handleStyle} />
      <Grid
        loading={status === "loading"}
        fetchingMore={isFetchingNextPage}
        prefix={prefix}
        items={items}
        filters={state}
        callOutCards={callOutCards}
      />
    </>
  )
}

export default ArticleCombinationGrid
